<ion-content *ngIf="!showDiscardButton; else autoHeightContent" [scrollY]="false" class="confirmation-content">
  <ng-container *ngTemplateOutlet="modalBody"></ng-container>
</ion-content>

<!-- ion-content can't grow with its content, so the Save/Discard/Cancel variant uses a plain container. -->
<ng-template #autoHeightContent>
  <div class="confirmation-content auto-height">
    <ng-container *ngTemplateOutlet="modalBody"></ng-container>
  </div>
</ng-template>

<ng-template #modalBody>
  <img class="close-icon" tooltip="{{'Close' | translate }}" alt="" placement="bottom" (click)="closeModal()" src="assets/icon/cancel.svg">
  <div class="title" [ngClass]="{'has-notice': noticeMessage, 'single-line-title': keepTitleInSingleLine, 'flow-layout': showDiscardButton}" *ngIf="confirmationTitle">
    <span class="confirmation-title-text" [tooltip]="isTruncated(confirmationTitle, titleMaxChars) ? confirmationTitle : null" placement="top">{{ truncateWithEllipsis(confirmationTitle, titleMaxChars) }}</span>
    <span class="confirmation-message" [class.full-message]="useFullMessage" *ngIf="confirmationMessage" [tooltip]="!useFullMessage && isTruncated(confirmationMessage, messageMaxChars) ? confirmationMessage : null" placement="top">{{ useFullMessage ? confirmationMessage : truncateWithEllipsis(confirmationMessage, messageMaxChars) }}</span>
    <span class="subtitle" *ngIf="confirmationSubtitle" [tooltip]="isTruncated(confirmationSubtitle, messageMaxChars) ? confirmationSubtitle : null" placement="top"><strong>{{ truncateWithEllipsis(confirmationSubtitle, messageMaxChars) }}</strong></span>
    <div class="notice-block" *ngIf="noticeMessage">
      <strong *ngIf="noticeTitle">{{ noticeTitle }}: </strong>
      <span>{{ noticeMessage }}</span>
    </div>
    <div class="confirmation-checkbox-row" *ngIf="showConfirmationCheckbox">
      <input
        id="confirmation-checkbox"
        class="confirmation-checkbox checkBoxItem"
        type="checkbox"
        [(ngModel)]="isConfirmationCheckboxChecked">
      <label for="confirmation-checkbox" class="confirmation-checkbox-label">{{ confirmationCheckboxLabel }}</label>
    </div>
    <div class="button-container" *ngIf="showCancel || showDiscardButton || showActionButton">
      <ion-button *ngIf="showCancel" class="app-btn" shape="round" fill="outline" color="primary" (click)="closeModal()">
        {{ (cancelText || 'Cancel') | translate }}
      </ion-button>
      <ion-button *ngIf="showDiscardButton" class="app-btn" shape="round" fill="outline" color="primary" (click)="discard()">
        {{ (discardText || 'Discard') | translate }}
      </ion-button>
      <ion-button *ngIf="showActionButton" class="app-btn" shape="round" fill="outline" color="primary" (click)="confirm()">
        {{ actionText | translate }}
      </ion-button>
    </div>
  </div>
</ng-template>